export const queryKeys = {
  profile: ['profile'],
  bookings: ['bookings'],
  loyaltyAccounts: ['loyalty-accounts'],
  loyaltyBalance: ['loyalty-balance'],
  alertHistory: ['alert-history'],
  adminStats: ['admin-stats'],
  adminProductMetrics: (startDate: string, endDate: string) => ['admin-product-metrics', startDate, endDate] as const,
  adminEmailEngagement: (startDate: string, endDate: string, alertType: string) =>
    ['admin-email-engagement', startDate, endDate, alertType] as const,
  adminUsers: ['admin-users'],
  adminRecentlyVerified: (limit: number) => ['admin-recently-verified', limit] as const,
  adminBilling: (userId: string) => ['admin-billing', userId] as const,
  adminSearchQuota: (userId: string) => ['admin-search-quota', userId] as const,
  adminBookings: ['admin-bookings'],
  transferBonuses: ['transfer-bonuses'],
  pendingTransferBonuses: ['pending-transfer-bonuses'],
  recentSearches: ['recent-searches'],
  userCreditCardPrograms: ['user-credit-card-programs'],
  availableLoyaltyPrograms: ['available-loyalty-programs'],
  airlineLoyaltyPrograms: ['airline-loyalty-programs'],
  savedFlights: ['saved-flights'],
  notifications: ['notifications'],
  notificationUnreadCount: ['notification-unread-count'],
  analyticsKpis: (filter: string) => ['analytics-kpis', filter] as const,
  analyticsSearchVolume: (filter: string) => ['analytics-search-volume', filter] as const,
  analyticsSaverAI: (filter: string) => ['analytics-saverai', filter] as const,
  analyticsPopularRoutes: (filter: string) => ['analytics-popular-routes', filter] as const,
  analyticsTopSavings: (filter: string) => ['analytics-top-savings', filter] as const,
  analyticsSubscriptions: (filter: string) => ['analytics-subscriptions', filter] as const,
  analyticsLoyalty: (filter: string) => ['analytics-loyalty', filter] as const,
  analyticsGeography: (filter: string) => ['analytics-geography', filter] as const,
  analyticsDevices: (filter: string) => ['analytics-devices', filter] as const,
  analyticsRecommended: (filter: string) => ['analytics-recommended', filter] as const,
  // POINTS-332/334: blog query keys. Public list is keyed by category so the
  // section filter cache-busts cleanly; detail is keyed by slug.
  blogPosts: (category: string) => ['blog-posts', category] as const,
  blogPost: (slug: string) => ['blog-post', slug] as const,
  adminBlogPosts: ['admin-blog-posts'],
  adminBlogMetrics: (startDate: string, endDate: string) =>
    ['admin-blog-metrics', startDate, endDate] as const,
} as const
